import { useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";
import { track } from "../lib/analytics";
import { toast } from "sonner";

export function NewsletterSignup({ variant = "footer" }) {
  const [email, setEmail] = useState("");
  const [kvkk, setKvkk] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!kvkk) { toast.error("Lütfen KVKK onayını işaretleyin."); return; }
    setLoading(true);
    try {
      await api.post("/newsletter", { email, kvkk, hp: "" });
      track("newsletter_signup", { source: variant });
      setDone(true);
      setEmail("");
      toast.success("Teşekkürler! Bilgece Mektup'a kaydoldun.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const dark = variant === "footer";

  if (done) {
    return <p data-testid="newsletter-success" className={dark ? "text-brand-gold-light text-sm" : "text-brand-green text-sm"}>Kaydın alındı. Düşünmeye değer fikirlerle görüşmek üzere.</p>;
  }

  return (
    <form onSubmit={submit} data-testid={`newsletter-form-${variant}`} className="space-y-3">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="E-posta adresin"
        data-testid="newsletter-email-input"
        className={`w-full px-4 py-3 text-sm rounded-sm outline-none border ${
          dark ? "bg-brand-green2 border-brand-offwhite/20 text-brand-offwhite placeholder:text-brand-offwhite/40 focus:border-brand-gold"
               : "bg-white border-brand-gold-light/50 text-brand-text focus:border-brand-gold"
        }`}
      />
      <label className={`flex items-start gap-2 text-xs ${dark ? "text-brand-offwhite/60" : "text-brand-text/60"}`}>
        <input type="checkbox" checked={kvkk} onChange={(e) => setKvkk(e.target.checked)} data-testid="newsletter-kvkk" className="mt-0.5 accent-brand-gold" />
        <span>Kişisel verilerimin işlenmesine (KVKK) onay veriyorum.</span>
      </label>
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit"
        className="w-full bg-brand-gold text-brand-offwhite hover:bg-brand-gold-light hover:text-brand-green transition-colors px-4 py-3 text-sm font-semibold rounded-sm disabled:opacity-60"
      >
        {loading ? "Kaydediliyor..." : "Abone Ol"}
      </button>
    </form>
  );
}
